import { registerWidget } from '@/widget-mount.js';
import UsMapWidget from './index.vue';
import '@/style.css';

// Register this widget with the global registry
// The ID must match the PHP widget's get_widget_id() return value
registerWidget('us-map', UsMapWidget);
